var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"size":"sm","variant":"light","href":_vm.backend_url + this.item.config.final_document.url,"target":"_blank"}},[_c('icon',{attrs:{"name":"download"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }